import { render, staticRenderFns } from "./DatabaseConnector.vue?vue&type=template&id=48e4fefc"
import script from "./DatabaseConnector.vue?vue&type=script&lang=js"
export * from "./DatabaseConnector.vue?vue&type=script&lang=js"
import style0 from "./DatabaseConnector.vue?vue&type=style&index=0&id=48e4fefc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports